/* eslint-disable radix */
/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-flexbox-grid';
import { reduxForm } from 'redux-form/immutable';
import styled from 'styled-components';
import Loader from '../../../shared/components/Loader/Loader';
//import AsyncComponent from '../../../shared/components/AsyncComponent';
import { Modal, ModalTitle, ModalFooter } from '@vds/modals';
import { Button, TextLink } from '@vds/buttons';
import { withRouter } from 'react-router-dom';
import ProgressBar from '../../../shared/components/ProgressBar';
import { RadioButtonGroup, RadioButton } from '@vds/radio-buttons';
import { dispatchPageView } from '../../../shared/Tagging/tagging';
import reactStringReplace from 'react-string-replace';
import { isUnAuth } from "../../../shared/services/httpClient";
import apiUrl from '../../../shared/utilities/apiUrl';
import common from "../../../shared/utilities/util";
import CountryListModal from '../../../shared/components/CountryListModal';


//const RadioButton = AsyncComponent(() => import('../../../shared/components/RadioButton'));


const PrimaryButton = styled(Button)`
border: 0,
position: 'absolute',
background: 'transparent',
borderSize: 0,
top: 10,
right: 30,
outline: 'none',
padding: '0px',
`;

const StyledButton = styled(Button)`
@media(max-width:768px){
  margin-left:30%;
}
`;

const DeviceDiv = styled.div`
@media(min-width:768px){
 padding-left: 9%;
}
`;



const ProgressDiv =styled.div`
@media(max-width: 768px){
padding:0px;
}
`;

class DeviceSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openAdvisoryModal: false,
      advisoryModalContent: null,
      openAdvisoryModalOnModal: false,
      advisoryModalContentOnModal: null,
      openCountryListModal:false,
      radioValue: false,
      radioValuenumber: 0,
      friendlyExperience: false,
      radioIndex: -1,
      deviceName:null
    };
  }

  componentDidMount() {
    if(typeof(window.vzdl) == "undefined"){
      console.log("vzdl not defined");
    }
    else {
      window.vzdl.user.authStatus= "logged in";
      window.vzdl.env.businessUnit=  "wireless";
 
    window.vzdl && window.vzdl.target && window.vzdl.target.engagement && window.vzdl.target.engagement.intent!=undefined && (window.vzdl.target.engagement.intent = "account management");
    window.vzdl.user.authStatus = isUnAuth() ? "anonymous" : "logged in";
    window.vzdl.page.displayChannel= "VZW";      
    window.vzdl.page.flow = "intl itp cpc";
    window.vzdl.page.detail = "Devices";
    window.vzdl.page.name="DeviceSelection";
    window.vzdl.page.sourceChannel= "VZW";
    dispatchPageView('DeviceSelection');
    }

  }
  
  getObjectFromArray(list, key, value) {
    const obj = list.find((item) => item[key] === value);
    if (obj) {
      return obj;
    }
    return {};
  }

  _onSubmitDevices(formValues) {
    //added for canada and mexico
    // let destination = [];
    // this.props.selectedDestList && this.props.selectedDestList.map((ite, index) => (
    //   ite.key !== 'MEX' && ite.key !== 'CAN' &&
    //   destination.push(ite.key)
    // ))

    // let containsCanadaAndMexicoOnly = destination.length === 0;
    const selectedDestList = this.props?.selectedDestList || [];
    let lengthCheck = (selectedDestList?.length && selectedDestList?.filter((item) => item.key === "CSP" || item.key === "AAA").length);
    let isCruiseAirThere = (lengthCheck != 0 && lengthCheck <= 2)? true : false;
    const deviceSelectionURL = this.props?.data?.device?.ctaList[0]?.ctaUrl;
    const selectedMtn = this.props?.data?.device?.mtnDetails && this.props.data.device.mtnDetails.find((item)=> item.mtn == this.state.radioValuenumber);
    this.props.actions.setSelectedMdnValue(this.state);
    // this.props.history.push({ pathname: deviceSelectionURL });
    if(selectedMtn.friendlyExperience && !isCruiseAirThere){
      this.props.history.push({ pathname: "/itpreview" });
    }
    else{
      this.props.history.push({ pathname: deviceSelectionURL });
    }
    // const selectedMtns = [];
    // selectedMtns.push(formValues.values.deviceSelection);
    // const inputEle = document.getElementById('deviceSubmitObject');
    // inputEle.value = JSON.stringify({ selectedMtns });
    // document.getElementById('submitDevices').submit();
  }

  _onAdvisoryLinkClick(device) {
    const advisoryMessage = device.advisory;
    if(this.props.data.advisoryDetails && this.props.data.advisoryDetails[advisoryMessage]){
    this.setState({
      openAdvisoryModal: true,
      advisoryMessage: advisoryMessage,
      advisoryModalContent: this.props.data.advisoryDetails[advisoryMessage],
      selectedDevice: device,
    });
    }
  }

  modalChanged = showModal => {
    this.setState({ openAdvisoryModal: showModal });
    if(!showModal)
      this.props.history.goBack(1)
  };

  _onAdvisoryModalLinkClick(advisoryMessage) {
    this.setState({
      openAdvisoryModalOnModal: true,
      advisoryModalContentOnModal: this.props.data.advisoryDetails[advisoryMessage],
    });
  }

  _onAdvisorymodalChanged = showModal => {
    this.setState({ openAdvisoryModalOnModal: showModal });
  };

  _onAdvisoryModalDecisionClick(url) {
    if (url && url !== '') {
      window.location.href = url;
    } else {
      this.setState({ openAdvisoryModalOnModal: false });
    }
  }

  _renderAdvisorySubHeading(list, device) {
    let messageSubText = '';
    if (device.nickName && device.nickName !== '') {
      const subTextObj = list && list.length > 0 && this.getObjectFromArray(list, 'subHeadingHint', 'sub_heading1_nickname').subText;
      messageSubText = subTextObj && subTextObj.replace('#nickName#', device.nickName);
    } else {
      const subTextObj = list && list.length > 0 && this.getObjectFromArray(list, 'subHeadingHint', 'sub_heading1_mtn').subText;
      messageSubText = subTextObj && subTextObj.replace('#formatedMtn_withHypen#', device.formatedMtn_withHypen);
    }
    return <p data-testid="renderAdvisorySubheading">{messageSubText}</p>;
  }

  _replaceStringFromObj(obj, string) {
    let replacedString = string;
    for (const val in obj) {
      if (replacedString && replacedString.includes && replacedString.includes(`#${val}#`)) replacedString = replacedString.replace(`#${val}#`, obj[val]);
      if(replacedString && replacedString.includes && replacedString.includes("\\u00A2")) replacedString = replacedString.replace(/\\u00A2/g, '¢');
    }
    return replacedString;
  }

  onCountryLinkClick = (offerName) => {
    const countryListObject = { "offerName": offerName };
    let sApiUrl = isUnAuth() ? apiUrl().itpcountryListByPlanUrl_ua : apiUrl().itpcountryListByPlanUrl;
    this.props.CountryListActions.contryListApi(sApiUrl, countryListObject);
    this.setState({
      openCountryListModal: true,
    });
  }

  _renderGrandFatherPlanContent(content, device) {
    return (
      content && device.grandFatheredPlanDetails && <div>
        <div data-testid="grandfatherplancontent"style={{ backgroundColor: '#FFBC3D' }} className="pad12">{content.advisoryList && content.advisoryList.length > 0 && content.advisoryList.map((item, index) => <p data-testid="grandHeading" key={'grandFatherStatus' + index} className="bold">{item.statusMessage && item.statusMessage.replace('#plan_cost#', device.grandFatheredPlanDetails.plan_cost)}</p>)}</div>
        <div className="pad30 onlyTopPad">
          {content.subHeading && content.subHeading.length > 0 && content.subHeading.map((item, index) => (
            item.subHeadingHint !== 'below_Heading' && item.subHeadingHint !== 'sub_heading1_nickname' && item.subHeadingHint !== 'sub_heading1_mtn' && <div key={'advisory' + index} style={{ maxWidth: '300px',lineHeight:'1.6',fontSize:'14px' }}>
              {item.subText.includes('#plan_cost#') ? <p className="fontsize_9 bold pad12 onlyBottomPad">{item.subText.replace('#plan_cost#', device.grandFatheredPlanDetails.plan_cost)}</p> : (
                item.subText.includes('#statusMessagecta_1#') ? (reactStringReplace(item.subText, '#statusMessagecta_1#', (match, i) => (
                  <TextLink
                    data-testid="grandfatherplancontent_textlink"
                    type="inline"
                    inverted={false}
                    disabled={false}
                    class={"textDecUnderline globalCountryListModalLink"}
                    onClick={(e)=>{this.onCountryLinkClick("MONTHLY")}}>
                    {item.ctaList[0].ctaLabel}
                  </TextLink>
                ))) : <p data-testid="grandfatherplancontent_subText">{item.subText}</p>
              )}
            </div>
          ))}
        </div>
        {content.includes && <div className="pad20 onlyTopPad">
          <p data-testid="grandfatherplancontent_incluestext" className="bold">{content.includes.includesHeading}</p>
          <ul>
            {content.includes.bulletPoints && content.includes.bulletPoints.map((item, index) => (
              <li className='fontSize_1' key={'bulletPoint' + index} dangerouslySetInnerHTML={{ __html: this._replaceStringFromObj(device.grandFatheredPlanDetails, item.text) }} />
            ))}
          </ul>
        </div>}
        {content.footer && <div className="pad12 onlyTopPad">
          <p   data-testid="grandfatherplancontent_footer" dangerouslySetInnerHTML={{ __html: this._replaceStringFromObj(device.grandFatheredPlanDetails, content.footer.overages) }} />
        </div>}
      </div>
    );
  }
  _renderGrandFatherModelData(data, devicedata) {
    return (
      (data && data.ctaList && data.ctaList.length !== 0 ?
        <p>
          {data.subText.replace('#cta_1#', data.ctaList[0].ctaLabel)}
        </p> :
        <p className={data.subHeadingBold === 'Yes' ? 'bold' : ''}>
          {data.subText.search('#planCost#') === -1 ? data.subText : data.subText.replace('#planCost#', parseInt(devicedata.grandFatheredPlanDetails.planCost))}
        </p>));
  }
  renderAdvisoryMessage(message) {
    return message && message.ctaList && message.ctaList.length > 0 && message.ctaList[0].ctaLabel;
  }

  // onChangeVal(e) {
  //   console.log(e.target.value);
  //   this.setState({
  //     radioValue: e.target.value
  //   })
  // }

  render() {
    const { deviceData, deviceSelectionForm, progressBarTabs } = this.props;
    //const buttonProp = (deviceSelectionForm && deviceSelectionForm.values && Object.keys(deviceSelectionForm.values).length > 0);
    return (
      <div data-testid="deviceselection" className='grid'>
        {this.props.isFetching && <Loader />}
        {progressBarTabs?.length > 0 && <ProgressDiv className="">
          <ProgressBar
            tabs={progressBarTabs}
            stepsCompleted={'3'}
          // backCtaUrl={data.output && data.output.output && data.output.output.previousPageUrl}
          />
        </ProgressDiv>}
        <span role="alert" style={{fontSize:'0', height:'0', width:'0'}}aria-live="polite">Travel dates completed and Device selection started </span>
        <DeviceDiv>
        <div className="pad20"  >
          <Row>
            <Col xs={12} md={8} lg={6} >
              <h1 style={{fontSize:'24px'}}className="fontSize_11" id="deviceOptionsGroupLabel" data-testid="heading">{deviceData?.heading}</h1>
              <div className="borderAfterHeading clearfix" />
              <div role="radiogroup" aria-labelledby="deviceOptionsGroupLabel">
              {deviceData?.mtnDetails?.map((device, index) => (
                <Row key={'device' + index} data-testid={'device' + index}>
                  <Col xs={12} lg={8} md={10}>
                    <div className="pad24 noSidePad border_cc onlyBottomBorder">
                      <Row style={{"marginLeft":"3%"}}>
                        <Col xs={1} data-testid={'Radio' + index} >
                          
                          <RadioButton
                          tabIndex="0" role='radio' ariaLabel={device.nickName + ' ' + device.mtn}
                            name={"deviceSelection"}
                            value={device.mtn}
                            disabled={device.isEligible !== 'Y'}
                            //analyticstrack="select-upgradeDevice-radio"
                            onChange={(e) => e.target.value ?
                              this.setState({
                                radioValue: true,
                                radioValuenumber: e.target.value,
                                radioIndex: index,
                                deviceName:device.deviceName,
                                deviceTypeCategory:device.deviceTypeCategory,
                                skuId:device.skuId,
                                brandName:device.brandName,
                                friendlyExperience: device.friendlyExperience
                              }) : ''
                            }
                            selected={this.state.radioIndex === index}
                            data-analyticstrack="select-upgradeDevice-radio"
                          />
                         

                        </Col>
                        <Col xs={10}>
                          <div style={{ color: device.isEligible !== 'Y' ? '#D8DADA' : '' }}>
                            <p className="bold margin5 onlyBottomMargin" data-testid={`deviceNickName${index}`}>{device.nickName}</p>
                            <p className="margin5 onlyBottomMargin">{device.formatedMtn}</p>
                            {device.advisory && device.advisory !== '' && <TextLink
                             type="inline" role="button" style={{ fontSize: "0.9rem" }} data-testid={`UTV${index}`} className="textDecUnderline" onClick={() => this._onAdvisoryLinkClick(device)}>{deviceData.advisoryList && deviceData.advisoryList.length > 0 && this.renderAdvisoryMessage(deviceData.advisoryList.find((item) => item.messageCode === device.advisory))}</TextLink>}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              ))}
              </div>
              <div className="pad42 onlyTopPad margin12 onlyBottomMargin alignButtonCenter">
                <StyledButton
                  style={{ minWidth: '8rem' }}
                  data-testid="submitDevice"
                  size='large'
                  inverted={false}
                  /*  style={{ paddingTop: '8px', height: '42px', fontSize: 'large' }} */
                  analyticstrack="confirm-cta"
                  className="button primary "
                  disabled={!this.state.radioValue}
                  onClick={this._onSubmitDevices.bind(this, deviceSelectionForm)} >
                  {deviceData?.ctaList[0].ctaLabel}
                </StyledButton>
              </div>
            </Col>
          </Row>
        </div>
        </DeviceDiv>
        {/* Modal */}
        {this.state.openAdvisoryModal && (<Modal
          opened={this.state.openAdvisoryModal}
          style={{ maxWidth: 570 }}
          showCloseX="true"
          onOpenedChange={this.modalChanged}
          taggingId={`advisory-modal-${this.state.selectedDevice && this.state.selectedDevice.mtn}`}
        >
          <ModalTitle>{this.state.advisoryModalContent && this.state.advisoryModalContent.heading}</ModalTitle>
          <div className="pad20 onlyRightPad">
            {this.state.advisoryModalContent && <div>
              <div className="pad12 noSidePad border_bottom_thick" data-testid="advisorySubHeading">
                {/*  <h4 className="pad6 noSidePad">{this.state.advisoryModalContent.heading}</h4> */}
                {this.state.advisoryModalContent.subHeading && this.state.advisoryModalContent.subHeading.length > 0 && <p>{this.getObjectFromArray(this.state.advisoryModalContent.subHeading, 'subHeadingHint', 'below_Heading').subText}</p>}
                {this._renderAdvisorySubHeading(this.state.advisoryModalContent.subHeading, this.state.selectedDevice)}
              </div>
              {this.state.advisoryMessage === 'GRANDFATHER_PLAN_MTN' && this.state.selectedDevice && this.state.selectedDevice.grandFatheredPlanDetails ?
                <div className="pad12 onlyTopPad">{this._renderGrandFatherPlanContent(this.state.advisoryModalContent, this.state.selectedDevice)}</div> :
                <>
                  {this.state.advisoryModalContent.subHeading && this.state.advisoryModalContent.subHeading.length > 0 && this.state.advisoryModalContent.subHeading.map((item, index) => (
                    <div className="pad12 onlyTopPad" data-testid={`AdvisoryModalSubheading${index}`}>

                      {item.subHeadingHint !== 'below_Heading' && item.subHeadingHint !== 'sub_heading1_nickname' && item.subHeadingHint !== 'sub_heading1_mtn' && <div key={'advisory' + index}>
                        {item.advisoryMsg && item.advisoryMsg !== '' ?
                          <div className="pad20 noSidePad border_e6 onlyBottomBorder">
                            <Row>
                              <Col xs={12} lg={7} md={7}>
                                <p className={item.subHeadingBold === 'Yes' ? 'bold pad12 onlyRightPad' : 'pad12 onlyRightPad'}>{item.subText2}</p>
                              </Col>
                              <Col xs={12} lg={5} md={5}>
                                <p className=""><a className="textDecUnderline" data-testid={'text' + index} onClick={() => this._onAdvisoryModalLinkClick(item.advisoryMsg)}>{item.subText}</a></p>
                              </Col>
                            </Row>
                          </div> :
                          <div className="pad12 onlyTopPad" style={{ maxWidth: '300px' }}>
                            <p>{this._renderGrandFatherModelData(item, this.state.selectedDevice)}</p>

                          </div>
                        }
                      </div>}

                    </div>))}</>
              }

            </div>}
          </div>
          {/* <ModalFooter> */}
            {this.state.advisoryModalContent && <div  style={{ display: 'inline-flex', justifyContent: 'center', width: '100%' }}>
              {this.state.advisoryModalContent.ctaList && this.state.advisoryModalContent.ctaList.length > 0 && this.state.advisoryModalContent.ctaList.map((item, index) => (
              <div style={{ display: 'inline-flex' }} className="margin30 onlyTopMargin alignButtonCenter">
                <PrimaryButton analyticstrack="Manage/Add-plans-view" size="large" /* style={{ paddingTop: '6px', height: '42px', fontSize: 'small' }} */ className="button primary margin12 onlyRightMargin"
                  data-testid="advisoryModalClose"
                  disabled={this.state.arrivalDate === null}
                    onClick={() => {
                      this.props.history.goBack(1)
                      this.setState({ openAdvisoryModal: false })
                    }
                    }>
                  {item.ctaLabel}</PrimaryButton>
              </div>
              ))}
              </div>}
          {/* </ModalFooter> */}
        </Modal>)}

        {this.state.openAdvisoryModalOnModal && (<Modal
          opened={this.state.openAdvisoryModalOnModal}
          style={{ maxWidth: 450 }}
          showCloseX="true"
          //closeFn={() => this.setState({ openAdvisoryModalOnModal: false })}
          onOpenedChange={this._onAdvisorymodalChanged}
          taggingId={`advisory-modal-details-${this.state.selectedDevice && this.state.selectedDevice.mtn}`}
        >
          <ModalTitle>
            <div className="pad20 onlyBottomPad border_bottom_thick">{this.state.advisoryModalContentOnModal && this.state.advisoryModalContentOnModal.heading}</div>
          </ModalTitle>
          <div className="pad20 onlyRightPad">
            {this.state.advisoryModalContentOnModal && <div>
           
              <div className="pad24 noSidePad">
                {this.state.advisoryModalContentOnModal.subHeading && this.state.advisoryModalContentOnModal.subHeading.length > 0 && this.state.advisoryModalContentOnModal.subHeading.map((subItem, index) => (
                  <div key={'advisory' + index} className="pad12 onlyBottomPad">
                    <p className={subItem.subHeadingBold === 'Yes' ? 'bold' : ''}>{subItem.subText}</p>
                  </div>
                ))}
              </div>


            </div>}
          </div>
          <ModalFooter>
            {this.state.advisoryModalContentOnModal && <div style={{ display: 'inline-flex', justifyContent: 'center', width: '100%' }} className="margin30 onlyTopMargin alignButtonCenter">
              {this.state.advisoryModalContentOnModal.ctaList && this.state.advisoryModalContentOnModal.ctaList.length > 0 && this.state.advisoryModalContentOnModal.ctaList.map((item, index) => (
                  <div className='margin12 onlyRightMargin'><PrimaryButton
                  data-testid= {"onModal"+index}
                  /*   style={{ paddingTop: '6px', height: '42px', fontSize: 'small' }} */
                  className={`button margin12 onlyRightMargin ${item.ctaLocator == 'right' ? 'secondary' : 'primary'}`}
                  analyticstrack={`${item.ctaLabel}-cta`}
                  size="large"
                  key={'button' + index}
                  disabled={this.state.arrivalDate === null}
                  onClick={() => this._onAdvisoryModalDecisionClick(item.ctaUrl)}
                >
                  {item.ctaLabel}</PrimaryButton></div>

              ))}
            </div>}
          </ModalFooter>
        </Modal>)}

        {this.state.openCountryListModal && (
          <CountryListModal
          showModal={this.state.openCountryListModal}
          closeModal={() => this.setState({ openCountryListModal: false })}
          countryList={this.props.countryListData?.countries}
          modelHeading={this.props.countryListData?.heading}
          modelLabel={this.props.countryListData && this.props.countryListData.textField.length > 0 && this.props.countryListData.textField[0].fieldLabel}
          ctaLabel={this.props.countryListData && this.props.countryListData.ctaList.length && this.props.countryListData.ctaList[0].ctaLabel}
          modalID={`countyList-modal-${this.state.selectedPlanIndex}`}
        />
        )}
      </div >
    );
  }
}

DeviceSelection.propTypes = {
  isFetching: PropTypes.bool,
  deviceData: PropTypes.object,
  deviceSelectionForm: PropTypes.object,
  data: PropTypes.object,
};

export default withRouter(reduxForm({
  form: 'deviceSelectionForm',
})(DeviceSelection));
